import React from 'react';
import { ArrowRight } from 'lucide-react';

type Props = {
  onViewAll: () => void;
};

export default function DietRecipes({ onViewAll }: Props) {
  return (
    <section className="mt-6">
      <button
        onClick={onViewAll}
        className="w-full relative overflow-hidden rounded-xl shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] group"
      >
        <div className="relative h-32">
          <img
            src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
            alt="Recettes diététiques"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-green-600/80 to-blue-600/80" />
          
          <div className="absolute inset-0 flex items-center justify-between px-6">
            <div className="text-white">
              <h2 className="text-xl font-bold mb-1">Recettes Diététiques</h2>
              <p className="text-white/90 text-sm">Sport, perte de poids & bien-être</p>
            </div>
            <div className="flex items-center text-white group-hover:translate-x-1 transition-transform">
              <ArrowRight size={24} />
            </div>
          </div>
        </div>
      </button>
    </section>
  );
}